import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// onApri e navigate di TestataPratica.js / PercorsoBar.js, più useModalita() di PercorsoBar.js.
//
// Apertura di un passo. Un passo, «Passo successivo», «Riepilogo del progetto» o «Vai» mandano l'evento annullabile
// "apri-passo:apri" ({ n }, bolle fino a document); se nessuno lo annulla si apre l'indirizzo del passo con Turbo.
// Senza `n` (Verifica bandi, una scheda) si va sempre all'indirizzo, come l'originale che chiamava navigate.
// Contratto per le pagine (T53, piani 04/05): una pagina che mostra il passo da sé annulla l'evento (preventDefault,
// sincrono, come onApri che rende true) e da quel momento aggiorna essa stessa ciò che dipende da `attivo` nella
// testata: aria-current="step" e ring-2 ring-navy del passo, ring-1 ring-oro del successivo, «Sei qui»/«Vai» della
// prossima azione, aria-current="page" di «Riepilogo del progetto». Il modo semplice: rendere di nuovo
// progetti/_testata_pratica con il nuovo `attivo` (visita Turbo a ?passo=n con morph, o il frame/stream che contiene
// la testata). Una pagina che non annulla non deve fare nulla: la visita rende la testata con il nuovo passo.
//
// Note dei passi (PercorsoBar.js:41): in «Semplice» restano nascoste; al cambio di modalità senza ricaricare
// (evento "modalita:cambiata" di modalita_controller) si mostrano o si nascondono subito.
//
//   <nav data-controller="apri-passo" data-action="modalita:cambiata@window->apri-passo#modalita">
//     <button data-action="apri-passo#apri" data-apri-passo-n-param="3" data-apri-passo-url-param="/app/progetto/p1?passo=3">
//     <div data-apri-passo-target="nota" hidden>…</div>
//   Un pulsante fuori dalla barra porta il controller su di sé: <button data-controller="apri-passo" data-action=…>
export default class extends Controller {
  static targets = ["nota"]

  apri(event) {
    const { n, url } = event.params
    if (n === undefined || !this.dispatch("apri", { detail: { n }, cancelable: true }).defaultPrevented) Turbo.visit(url)
  }

  modalita(event) {
    const semplice = (event.detail?.modalita || document.body.dataset.modalita) === "semplice"
    this.notaTargets.forEach((el) => { el.hidden = semplice })
  }
}
